import React, { useState, useRef } from 'react';
import '../styles/floatingButtons.css';

const BackgroundMusic = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  const togglePlay = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play().catch((error) => console.error('Play error:', error));
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <div className="floating-button">
      <audio ref={audioRef} loop>
        <source src="/music/background-music.mp3" type="audio/mpeg" />
        Your browser does not support the audio element.
      </audio>
      <button className="floating-button-icon" onClick={togglePlay}>
        <i className={`fas ${isPlaying ? 'fa-volume-up' : 'fa-volume-mute'}`}></i> 
      </button>
    </div>
  );
};

export default BackgroundMusic;
